interface ShareBarProps {
  width: number;
  color: string;
}

export function ShareBar({ width, color }: ShareBarProps) {
  return (
    <div style={{ display: 'flex', flexFlow: 'column', alignItems: 'flex-start' }}>
      <span style={{ fontWeight: 'bold', color }}>{width.toFixed(2)}%</span>
      <div
        style={{
          width: '100%',
          height: '12px',
          border: '1px solid var(--core-border-tertiary, #E6E6E6)',
          backgroundColor: 'white',
          position: 'relative',
          overflow: 'hidden',
        }}
      >
        <div
          style={{
            backgroundColor: color,
            height: '100%',
            width: `${width}%`,
            position: 'absolute',
            top: 0,
            left: 0,
          }}
        />
      </div>
    </div>
  );
}
